import { validationTranslations } from './constants';
import { isValidEmail } from '../../validation/email';
import { isValidPhoneNumber } from '../../validation/phone';
import { normalizeValue } from 'app/infrastructure/simple-form/utils';

import get from 'lodash/get';

export enum ValidationRule {
  IgnoreCaseSensitivity = 'ignoreCaseSensitivity'
}

const getNormalized = (t: any, s: string, rules: ValidationRule[] = []) => rules.length > 0
  ? rules.reduce((normalized, rule) => validationRules[rule]?.(normalized) ?? normalized, normalizeValue(get(t, s)))
  : normalizeValue(get(t, s));

const ignoreCaseSensitivity = value => typeof value === 'string' ? value.toLowerCase() : value;

const validationRules: { [key in ValidationRule]: (value: any) => typeof value } = {
  [ValidationRule.IgnoreCaseSensitivity]: ignoreCaseSensitivity
};

export const requiredValidation = (field: string) => (data: any, translation: (id: number) => string) => {
  const value = getNormalized(data, `${field}.value`);
  return !value || (value.value === '' || value.value === 0) || value === ''
    ? { field, message: translation(validationTranslations.must_be_filled) }
    : undefined;
};

export const equalsValidation = (field: string, otherFields: string | string[]) => (data: any, translation: (id: number) => string) => {
  const value = getNormalized(data, `${field}.value`);

  const notEquals = Array.isArray(otherFields)
    ? (otherFields as string[]).some(
      otherField => value !== getNormalized(data, `${otherField}.value`))
    : value !== getNormalized(data, `${otherFields}.value`);

  return notEquals
    ? { field: field, message: translation(validationTranslations.must_be_equal) }
    : undefined;
};

export const validateEmail = (field: string) => (data: any, translation: (id: number) => string) => {
  const value = getNormalized(data, `${field}.value`);

  return value && !isValidEmail(value)
    ? { field, message: translation(validationTranslations.email_invalid) }
    : undefined;
};

export const validatePhoneNumber = (field: string) => (data: any, translation: (id: number) => string) => {
  const value = getNormalized(data, `${field}.value`);

  return value && !isValidPhoneNumber(value)
    ? { field, message: translation(validationTranslations.phone_number_invalid) }
    : undefined;
};

export const uniqueValidation = (field: string, otherFields: string | string[], rules: ValidationRule[] = []) =>
  (data: any, translation: (id: number) => string) => {

    const value = getNormalized(data, `${field}.value`, rules);

    if (value === undefined || value === '') {
      return undefined;
    }

    const isEqual = Array.isArray(otherFields)
      ? (otherFields as string[]).some(otherField => value === getNormalized(data, `${otherField}.value`, rules))
      : value === getNormalized(data, `${otherFields}.value`, rules);

    return isEqual
      ? { field: field, message: translation(validationTranslations.must_be_unique) }
      : undefined;
  };
